import { RouteService } from 'app/services/route.service';
import { Injectable } from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {LoginService} from "../services/login.service";
import {environment, productModels} from "../../environments/environment";
import {AppConfig} from "../app.config";
import {current} from "codelyzer/util/syntaxKind";
import {ConfigService} from "../services/config.service";
import { TranslationService } from 'app/services/translation.service';


@Injectable()
export class AuthGuardService implements CanActivate {
  private state : RouterStateSnapshot;
  private language: string;
  constructor(private loginService : LoginService, 
              private router : Router,
              private appConfig : AppConfig, 
              private configService : ConfigService,
              private route : ActivatedRoute,
              private translationService: TranslationService,
              private routeService: RouteService,
            ) {
    this.defaultLanguage = this.configService.getDefaultLanguage();
  }

  defaultLanguage: string 
  
  canActivate(route : ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.getLanguageFromURL();

    this.state = state;
    let isLoggedIn = this.loginService.isLoggedIn();
    
    if(!isLoggedIn) {
      this.route.params["password"] = null;
      const code = route.queryParams && route.queryParams['code'];
      if (code) {
        this.router.navigate([this.language + '/login'], {
          queryParams: {
            code: route.queryParams['code'],
            state: route.queryParams['state'],
            session_state: route.queryParams['session_state']
          }
        });
      } else {
        this.router.navigate([this.language + '/login'], {
          queryParams: { returnUrl: state.url }
        });
      }

      return false;
    }
    else {
      return this.HandleProductAuth(route, isLoggedIn);
    }
  }

  getLanguageFromURL(){
    const pathParts = window.location.pathname.split("/");
    this.language = pathParts[1];

    if (this.language === undefined || this.language === '' || this.language.indexOf("?") !== -1){
      this.language = this.defaultLanguage;
    }
    if (this.language !== undefined) {
      this.changeLanguage(this.language);
    }
  }

  changeLanguage(language: string){
    this.translationService.setLanguage(language)
  }
  
  private HandleProductAuth(route :ActivatedRouteSnapshot, isLoggedIn : boolean)
  {
    let allowedModelsForRoute = route.data.allowedProductModels as Array<string>;
    
    let currentProductModel = this.appConfig.getConfig("productModel");
    
    let canAccess = allowedModelsForRoute.indexOf(currentProductModel) != -1;
    
    if(canAccess) {
      this.configService.changeCurrentRoute(this.state.url);
      return isLoggedIn;
    }
    else if(currentProductModel == productModels.Lite){
      this.router.navigate([this.language + '/task-administration']);
    }
    else if(currentProductModel == productModels.Premium)
    {
      this.router.navigate(['']);
    }
    else if(currentProductModel == productModels.Maintenance)
    {
      this.router.navigate([this.language + '/maintenancetasks']);
    }

  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/auth/auth-guard.service.ts